// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/js/views/event/EventDetails.css
// module id = 2062
// module chunks = 0